module.exports = __webpack_public_path__ + "avatar.svg?f357edc4b4818b2d4e50744aecdbbc3a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/avatar.svg
// module id = 16
// module chunks = 0